import type { OptimisationPath } from '@/types/Models/Shipment'

type OptimisationSummaryEntry = { carrierHandle: string; metadata: string | null }

const parseEntry = (entry: unknown): OptimisationSummaryEntry => {
  // Legacy format: [carrierHandle, metadata]
  if (Array.isArray(entry)) {
    return {
      carrierHandle: typeof entry[0] === 'string' ? entry[0] : '',
      metadata: typeof entry[1] === 'string' ? entry[1] : null,
    }
  }

  // Current format: "carrierHandle: metadata"
  if (typeof entry === 'string') {
    const [carrierHandle, ...rest] = entry.split(': ')
    return rest.length === 0
      ? { carrierHandle: '', metadata: entry }
      : { carrierHandle, metadata: rest.join(': ') }
  }

  return { carrierHandle: '', metadata: null }
}

export default class ShipmentTransformer {
  static normalizeOptimisationSummary(summary: unknown[]): OptimisationPath[] {
    return summary.map((entry) => ({ id: '', active: false, price: null, sequence: 0, type: '', ...parseEntry(entry) }))
  }
}
